import { client } from '@/lib/api/client'
import { venueProfilePath } from '@/lib/api/config'
import { toApiError } from '@/lib/api/errors'

import type { VenueProfileSaveInput, VenueProfileView } from './venueProfileTypes'

/**
 * `GET /venue/v1/manager/venues/{venueId}/profile` (#594 §1).
 * 🚨 게이팅 대상이 아니다 — 이용권이 모두 만료돼도 항상 200(정보 확인 입구를 막지 않는다).
 */
export async function fetchVenueProfile(venueId: string): Promise<VenueProfileView> {
  try {
    const { data } = await client.get<VenueProfileView>(venueProfilePath(venueId))
    return data
  } catch (error) {
    throw toApiError(error)
  }
}

/**
 * `PUT /venue/v1/manager/venues/{venueId}/profile` (#594 §2).
 * 🚨 전량 교체 — `input` 의 모든 필드를 그대로 보낸다(생략 필드가 있으면 서버가 미입력으로 저장한다).
 * 응답은 `GET` 과 동일한 최신 View 다(멱등 — 같은 값 재저장은 `profileUpdatedAt` 을 흔들지 않는다).
 */
export async function saveVenueProfile(
  venueId: string,
  input: VenueProfileSaveInput
): Promise<VenueProfileView> {
  try {
    const { data } = await client.put<VenueProfileView>(venueProfilePath(venueId), input)
    return data
  } catch (error) {
    throw toApiError(error)
  }
}
